export default __webpack_public_path__ + "static/media/01.647e4c97.svg";